import run from '../../utilities/run';
import $ from 'jquery';
import QuickWizard from '../../components/QuickWizard/QuickWizard';
import { setElementsFromScope, setOptionsForSelect, removeRequired, setRequired } from "../../utilities/selectorHelpers";
import { anyChecked } from './utilities';
import { isPresent } from '../../utilities/general';
import render from "../../utilities/render";
const _ = require("underscore");
import timePicker from "../../components/timePicker/timePicker";
require("./createChannelWizard.less");

var moment = require('moment');

export default function ConfigurationTab(wizard) {

  const self = this;
  const el = wizard.getWizardElement();
  self.init = function () {
    bindElements();
    orderProcessingDateTimeDropdown();
    if(!isPresent(retpartner)) {
      setRequired([orderProcessingDateTimeSelect]);
    }
    onLoad();
    
  };
  function bindElements() {
    orderProcessingTogglers.on("change", function () {
        toggleOrderProcessingDateTime(this.value, this.text);
    });
    orderProcessingDateTimeSelect.on('change', function () {
        orderProcessingSelectChanged(this.value, this.text);
    });
    timePicker(timePickerTarget);
    orderProcessingDateTimeSelectList = orderProcessingDateTimeSelect.data('options');
    inventorySyncTogglers.on("change", function () {
        toggleInventorySyncSwitch(this.id, this.value);
    });
  }

  function orderProcessingDateTimeDropdown() {
    let returnTypeList = "";
    returnTypeList = orderProcessingDateTimeSelectList.map((el) => {
        return render("<option value = '{%-key %}'>{%-value %}</option>", {
            key: el.cdmValue,
            value: el.cdmDescription

        });
    });
    orderProcessingDateTimeSelect.html(returnTypeList);
    orderProcessingDateTimeSelect.val("");
    orderProcessingDateTimeSelect.trigger('change');
  }

  function validateConfigTab() {
    let isValid = false;
    if (el.valid()) {
      isValid = true;
    }
    return isValid;
  }
  self.didNavigateToForm = function () {
   // validateConfigTab();
  };

  const retpartner = el.data("retailer-partners-info");
  const parName = el.data("par-name");
  const parId = el.data("partner-id");
  const amazonParId = el.data("amazon-par-id");
  const amazonMktPlcParId = el.data("amazon-market-palce-par-id");

  let startDateValue = el.data("start-date-value");
  let timePickerHoursSelectValue = el.data("time-picker-hours-select-value");
  let timePickerMinSelectValue = el.data("time-picker-minutes-select-value");
  let timePickerPeriodSelectValue = el.data("time-picker-period-select-value");


  const orderProcessingTogglers = el.find("#orderProcessingIcon");
  const inventorySyncTogglers = el.find(".inventory-sync-toggler");
  const orderProcessingDateTimeSelect = el.find("#orderProcessingDateTimeOptions");
  let orderProcessingDateTimeSelectList = orderProcessingDateTimeSelect.data('options');

  const orderProcessingDateTimeSection = el.find("#order-processing-date-time");
  const orderProcessingSelect = el.find("#order-processing-select");
  const dateTimePickerSection = el.find("#order-processing-date-time-picker");

  const orderProcessingIcon = el.find("#orderProcessingIcon");
  const inventorySyncIcon = el.find("#inventorySyncIcon");

  const startDate = el.find(".start-date");
  const timePickerHoursSelect = el.find(".time-picker-hours-select");
  const timePickerMinSelect = el.find(".time-picker-minutes-select");
  const timePickerPeriodSelect = el.find(".time-picker-period-select");

  const timePickerTarget = el.find('.time-picker');
  timePicker(timePickerTarget);

  let orderProcessingIconStatus = false;
  let inventorySyncIconStatus = false;
  let dateTime = "";
  let beginOrderProcessingFrom = "";


  function onLoad() {
    loadConfiguration(retpartner);
  }

  function loadConfiguration(data) {
    loadOrderProcessingConfiguration(data);
    loadInventorySyncConfiguration(data);
    toggleOrderProcessingDateTime(orderProcessingIcon, data.repOrdersProcessingFlag);
    let isOn = anyChecked(orderProcessingTogglers);
    if(isPresent(data) && isOn) {
      dateTimePickerSection.show();
      startDate.val(startDateValue);
      startDate.change();
      timePickerHoursSelect.val(timePickerHoursSelectValue);
      timePickerHoursSelect.change();
      timePickerMinSelect.val(timePickerMinSelectValue);
      timePickerMinSelect.change();
      timePickerPeriodSelect.val(timePickerPeriodSelectValue);
      timePickerPeriodSelect.change();
    }
    toggleInventorySyncSwitch(inventorySyncIcon, data.repInventorySyncFlag);

  }

  function loadOrderProcessingConfiguration(data) {
    if (data.repOrdersProcessingFlag) {
      $("#orderProcessingIcon").val(true);
      $("#orderProcessingIcon").prop('checked', true);
    } else {
      $("#orderProcessingIcon").val(false);
      $("#orderProcessingIcon").prop('checked', false);
    }

    beginOrderProcessingFrom = data.repPullOrdersUri;
  }

  function loadInventorySyncConfiguration(data) {
    if (data.repInventorySyncFlag) {
      $("#inventorySyncIcon").val(true);
      $("#inventorySyncIcon").prop('checked', true);
    } else {
      $("#inventorySyncIcon").val(false);
      $("#inventorySyncIcon").prop('checked', false);
    }
  }

  function toggleOrderProcessingDateTime(toggleSwitchId, toggleSwitchValue) {
    let isOn = anyChecked(orderProcessingTogglers);
    dateTimePickerSection.hide();
    if (isOn) {
      dateTimePickerSection.show();
      orderProcessingDateTimeSelect.change();
      orderProcessingTogglers.val(true);
      orderProcessingTogglers.prop('checked', true);
    } else {
      dateTimePickerSection.hide();
      orderProcessingSelectChanged(null, null);
      orderProcessingDateTimeSelect.val("");
      orderProcessingTogglers.val(false);
      orderProcessingTogglers.prop('checked', false);
    }

  }

  function toggleInventorySyncSwitch(toggleSwitchId, toggleSwitchValue) {
    let isOn = anyChecked(inventorySyncIcon);

    if (toggleSwitchId == "inventorySyncIcon") {
      if (isOn) {
        $("#inventorySyncIcon").val(true);
        $("#inventorySyncIcon").prop('checked', true);
      } else {
        $("#inventorySyncIcon").val(false);
        $("#inventorySyncIcon").prop('checked', false);
      }
    }

  }

  setOptionsForSelect({
    selectElement: orderProcessingDateTimeSelect,
    list: orderProcessingDateTimeSelectList,
    valueDataKey: "cdmValue",
    textDataKey: "cdmDescription"
  });

  function orderProcessingSelectChanged(val, text) {
    startDate.val("");
    timePickerHoursSelect.val("1");
    timePickerMinSelect.val("00");
    timePickerPeriodSelect.val("AM");
    if (val === "future" || val === "past") {
      dateTimePickerSection.show();
      setRequired([startDate]);
      setCalendarProperties(val);
    } else {
      removeRequired([startDate]);
      dateTimePickerSection.hide();
    }
    timePickerHoursSelect.change();
    timePickerMinSelect.change();
    timePickerPeriodSelect.change();
  }

  function setDateTimePeriodDefaultValue() {
    timePickerHoursSelect.val("1");
    timePickerMinSelect.val("00");
    timePickerPeriodSelect.val("AM");
  }
  function setCalendarProperties(selectedDropdownValue) {
    $(".func-date-range-input").datepicker("destroy"); 
    const date = new Date();
    if (selectedDropdownValue === "future") {
      $(".func-date-range-input").datepicker({
        minDate: date,
        todayBtn: "linked",
        keyboardNavigation: false,
        autoclose: true,
        forceParse: false,
        startDate: new Date()
      });
    } else if (selectedDropdownValue === "past") {
      $(".func-date-range-input").datepicker({
        todayBtn: "linked",
        endDate: new Date(),
        maxDate: date,
        keyboardNavigation: false,
        forceParse: false,
        autoclose: true
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/createChannel/configurationTab.js